import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=c1fb1478&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=c1fb1478&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1fb1478",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1fb1478')) {
      api.createRecord('c1fb1478', component.options)
    } else {
      api.reload('c1fb1478', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=c1fb1478&scoped=true&", function () {
      api.rerender('c1fb1478', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27a8OrIval0uW/JS/comp/SearchFilterTokens.vue"
export default component.exports